(function () {
  'use strict';

  var API_BASE = '/apps/floor-s';
  var root = document.getElementById('sp-root');
  if (!root) return;

  var DETAIL_URL = root.dataset.detailUrl || '/pages/subscription-detail';
  var SHOP_URL = root.dataset.shopUrl || '/collections/all';
  var WRITE_ENABLED = root.dataset.writeEnabled === 'true';
  var PAUSED_VISIBLE = 3;
  var store = {};
  var state = { token: null, cid: null, busy: false };

  var SV = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"';
  var ICON = {
    truck: '<svg ' + SV + '><path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"/></svg>',
    skip: '<svg ' + SV + '><path d="M4 5v14l12 -7z"/><path d="M20 5l0 14"/></svg>',
    cal: '<svg ' + SV + '><path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z"/><path d="M16 3v4M8 3v4M4 11h16"/></svg>',
    play: '<svg ' + SV + '><path d="M7 4v16l13 -8z"/></svg>',
    gear: '<svg ' + SV + '><path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"/><path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"/></svg>',
    pause: '<svg ' + SV + '><path d="M6 5m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"/><path d="M14 5m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"/></svg>',
    chev: '<svg ' + SV + '><path d="M9 6l6 6l-6 6"/></svg>',
    down: '<svg ' + SV + '><path d="M6 9l6 6l6 -6"/></svg>',
    x: '<svg ' + SV + '><path d="M18 6l-12 12M6 6l12 12"/></svg>',
    plus: '<svg ' + SV + '><path d="M12 5l0 14M5 12l14 0"/></svg>'
  };

  var WD = ['\u65e5', '\u6708', '\u706b', '\u6c34', '\u6728', '\u91d1', '\u571f'];
  var STATUS_JA = {
    ACTIVE: '\u304a\u5c4a\u3051\u4e2d', PAUSED: '\u304a\u4f11\u307f\u4e2d',
    CANCELLED: '\u89e3\u7d04\u6e08\u307f', EXPIRED: '\u7d42\u4e86',
    FAILED: '\u304a\u652f\u6255\u3044\u306e\u78ba\u8a8d\u304c\u5fc5\u8981', STALE: '\u78ba\u8a8d\u304c\u5fc5\u8981'
  };
  var IV = { DAY: '\u65e5', WEEK: '\u9031\u9593', MONTH: '\u30f6\u6708', YEAR: '\u5e74' };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function https(u) { return !u ? '' : (u.indexOf('//') === 0 ? 'https:' + u : u); }
  function parseDate(v) { if (!v) return null; var d = new Date(v); return isNaN(d.getTime()) ? null : d; }
  function fmtDate(d) {
    return !d ? '\u65e5\u4ed8\u672a\u5b9a'
      : (d.getMonth() + 1) + '\u6708' + d.getDate() + '\u65e5\uff08' + WD[d.getDay()] + '\uff09';
  }
  function fmtFull(d) { return !d ? '\u2014' : d.getFullYear() + '\u5e74' + fmtDate(d); }
  function daysUntil(d) {
    if (!d) return null;
    var t = new Date(); t.setHours(0, 0, 0, 0);
    return Math.round((new Date(d.getFullYear(), d.getMonth(), d.getDate()) - t) / 86400000);
  }
  function untilLabel(d) {
    var n = daysUntil(d);
    if (n === null) return '';
    if (n < 0) return '\u78ba\u8a8d\u4e2d';
    if (n === 0) return '\u672c\u65e5';
    if (n === 1) return '\u3042\u3059';
    return '\u3042\u3068' + n + '\u65e5';
  }
  function intervalLabel(c) {
    var p = c.deliveryPolicy || c.billingPolicy || {};
    if (!p.interval || !p.intervalCount) return '';
    return p.intervalCount + (IV[p.interval] || '') + '\u3054\u3068';
  }
  function idNum(gid) { if (!gid) return ''; var a = String(gid).split('/'); return a[a.length - 1]; }
  function gidOf(v) {
    if (!v) return '';
    if (String(v).indexOf('gid://') === 0) return v;
    return 'gid://shopify/SubscriptionContract/' + idNum(v);
  }
  function lines(c) {
    return ((c.lines && c.lines.edges) || []).map(function (x) { return x.node; }).filter(Boolean);
  }
  function lineName(n) {
    var t = n.title || '';
    var v = n.variantTitle;
    return v && v !== 'Default Title' ? t + ' ' + v : t;
  }
  function titleOf(c) {
    var l = lines(c);
    if (!l.length) return '\u5b9a\u671f\u4fbf';
    var base = lineName(l[0]);
    if (l.length > 1) base += '\u3000\u4ed6' + (l.length - 1) + '\u70b9';
    return base;
  }
  function imgTag(node, cls) {
    var u = https(node && node.variantImage ? node.variantImage.url : '');
    return u ? '<img class="' + cls + '" src="' + esc(u) + '" alt="" loading="lazy">'
             : '<div class="' + cls + '"></div>';
  }
  function thumb(c) { return imgTag(lines(c)[0], 'sp-thumb'); }
  function metaLine(c) {
    var l = lines(c);
    var q = l.length && l[0].quantity ? l[0].quantity + '\u70b9' : '';
    return [intervalLabel(c), q].filter(Boolean).join(' \uff0f ');
  }
  function href(c) { return DETAIL_URL + '?id=' + encodeURIComponent(idNum(c.contractId || c.id)); }

  function toast(msg, isErr) {
    var el = document.createElement('div');
    el.className = 'spd-toast' + (isErr ? ' is-err' : '');
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    setTimeout(function () {
      el.classList.remove('is-on');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 250);
    }, 3400);
  }

  function qs() {
    return '?customerId=' + encodeURIComponent(state.cid) + '&token=' + encodeURIComponent(state.token);
  }

  function call(method, path, body) {
    return fetch(API_BASE + path + qs(), {
      method: method, credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text().then(function (t) {
        if (!t) return {};
        try { return JSON.parse(t); } catch (x) { return {}; }
      });
    });
  }

  function heroHTML(c) {
    var d = parseDate(c.nextBillingDate), meta = metaLine(c);
    return '<div class="sp-hero">' +
      '<div class="sp-hero-label">' + ICON.truck + '<span>\u6b21\u56de\u306e\u304a\u5c4a\u3051</span></div>' +
      '<div class="sp-hero-date"><span>' + esc(fmtDate(d)) + '</span>' +
        '<span class="sp-sub">' + esc(untilLabel(d)) + '</span></div>' +
      '<div class="sp-hero-body">' + thumb(c) +
        '<div class="sp-hero-info"><p class="sp-hero-title">' + esc(titleOf(c)) + '</p>' +
        (meta ? '<p class="sp-hero-meta">' + esc(meta) + '</p>' : '') + '</div></div>' +
      '<div class="sp-actions">' +
        '<button type="button" class="sp-btn" data-act="skip" data-id="' + esc(c.contractId || '') + '">' +
          ICON.skip + '<span>1\u56de\u30b9\u30ad\u30c3\u30d7</span></button>' +
        '<a class="sp-btn" href="' + esc(href(c)) + '#date">' + ICON.cal + '<span>\u65e5\u4ed8\u3092\u5909\u66f4</span></a>' +
      '</div>' +
      '<a class="sp-detail-link" href="' + esc(href(c)) + '">\u3059\u3079\u3066\u306e\u8a2d\u5b9a\u3092\u898b\u308b</a></div>';
  }

  function cardHTML(c, metaText) {
    return '<a class="sp-card" href="' + esc(href(c)) + '">' + thumb(c) +
      '<div class="sp-card-info"><p class="sp-card-title">' + esc(titleOf(c)) + '</p>' +
      '<p class="sp-card-meta">' + esc(metaText) + '</p></div>' +
      '<span class="sp-chev">' + ICON.chev + '</span></a>';
  }

  function pausedHTML(c) {
    var id = esc(c.contractId || '');
    var bits = [STATUS_JA.PAUSED];
    var iv = intervalLabel(c);
    if (iv) bits.push(iv);
    return '<div class="sp-pcard">' +
      '<button type="button" class="sp-pcard-top" data-act="detail" data-id="' + id + '">' + thumb(c) +
        '<div class="sp-card-info"><p class="sp-card-title">' + esc(titleOf(c)) + '</p>' +
        '<p class="sp-card-meta">' + esc(bits.join(' \uff0f ')) + '</p></div>' +
        '<span class="sp-chev">' + ICON.chev + '</span></button>' +
      '<div class="sp-pcard-foot">' +
        '<button type="button" class="sp-btn sp-btn-resume" data-act="resume" data-id="' + id + '">' +
          ICON.play + '<span>\u518d\u958b\u3059\u308b</span></button>' +
        '<button type="button" class="sp-btn" data-act="detail" data-id="' + id + '">' +
          ICON.gear + '<span>\u5185\u5bb9\u3092\u898b\u308b</span></button>' +
      '</div></div>';
  }

  function addNewHTML() {
    return '<div class="sp-addnew">' +
      '<a class="sp-addnew-card" href="' + esc(SHOP_URL) + '">' +
        '<span class="sp-addnew-icon">' + ICON.plus + '</span>' +
        '<span class="sp-addnew-info">' +
          '<span class="sp-addnew-title">\u307b\u304b\u306e\u5b9a\u671f\u4fbf\u3092\u8ffd\u52a0\u3059\u308b</span>' +
          '<span class="sp-addnew-sub">\u65b0\u3057\u3044\u5546\u54c1\u3092\u3001\u5225\u306e\u5b9a\u671f\u4fbf\u3068\u3057\u3066\u304a\u7533\u3057\u8fbc\u307f\u3044\u305f\u3060\u3051\u307e\u3059</span>' +
        '</span><span class="sp-chev">' + ICON.chev + '</span></a></div>';
  }

  function sheetHTML(c) {
    var l = lines(c);
    var items = l.length
      ? l.map(function (n) {
          return '<div class="sp-item">' + imgTag(n, 'sp-thumb') +
            '<div class="sp-item-info"><p class="sp-item-title">' + esc(lineName(n)) + '</p>' +
            '<p class="sp-item-meta">' + esc((n.quantity || 1) + '\u70b9') + '</p></div></div>';
        }).join('')
      : '<p class="sp-item-meta">\u5546\u54c1\u60c5\u5831\u3092\u53d6\u5f97\u3067\u304d\u307e\u305b\u3093\u3067\u3057\u305f\u3002</p>';

    var facts = '<dl class="sp-facts">';
    var iv = intervalLabel(c);
    if (iv) facts += '<div class="sp-fact"><dt>\u304a\u5c4a\u3051\u9593\u9694</dt><dd>' + esc(iv) + '</dd></div>';
    facts += '<div class="sp-fact"><dt>\u518d\u958b\u5f8c\u306e\u4e88\u5b9a\u65e5</dt><dd>' +
      esc(fmtFull(parseDate(c.nextBillingDate))) + '</dd></div>';
    facts += '<div class="sp-fact"><dt>\u5951\u7d04\u756a\u53f7</dt><dd>' + esc(idNum(c.contractId || c.id)) + '</dd></div></dl>';

    return '<div class="sp-sheet" role="dialog" aria-modal="true" aria-label="\u5b9a\u671f\u4fbf\u306e\u5185\u5bb9">' +
      '<div class="sp-sheet-head"><h3>\u5b9a\u671f\u4fbf\u306e\u5185\u5bb9</h3>' +
        '<button type="button" class="sp-x" data-act="close" aria-label="\u9589\u3058\u308b">' + ICON.x + '</button></div>' +
      '<div class="sp-sheet-body">' +
        '<span class="sp-sheet-status">' + ICON.pause + '<span>' + esc(STATUS_JA[c.status] || '') + '</span></span>' +
        items + facts +
        '<div class="sp-sheet-actions">' +
          '<button type="button" class="sp-btn sp-btn-primary" data-act="resume" data-id="' + esc(c.contractId || '') + '">' +
            ICON.play + '<span>\u3053\u306e\u5b9a\u671f\u4fbf\u3092\u518d\u958b\u3059\u308b</span></button>' +
          '<a class="sp-btn" href="' + esc(href(c)) + '">' + ICON.gear + '<span>\u8a73\u7d30\u8a2d\u5b9a\u3092\u958b\u304f</span></a>' +
        '</div>' +
        '<p class="sp-sheet-note">\u518d\u958b\u3059\u308b\u3068\u3001\u6b21\u56de\u306e\u304a\u5c4a\u3051\u304b\u3089\u518d\u3073\u3054\u5229\u7528\u3044\u305f\u3060\u3051\u307e\u3059\u3002</p>' +
      '</div></div>';
  }

  var ov = null, lastFocus = null;
  function closeSheet() {
    if (!ov) return;
    var el = ov; ov = null;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openSheet(c) {
    closeSheet();
    lastFocus = document.activeElement;
    var el = document.createElement('div');
    el.className = 'sp-ov';
    el.innerHTML = sheetHTML(c);
    el.addEventListener('click', function (e) {
      if (e.target === el || e.target.closest('[data-act="close"]')) {
        e.preventDefault(); closeSheet(); return;
      }
      var r = e.target.closest('[data-act="resume"]');
      if (r) {
        e.preventDefault();
        closeSheet();
        doResume(r.dataset.id);
      }
    });
    document.body.appendChild(el);
    document.body.style.overflow = 'hidden';
    ov = el;
    requestAnimationFrame(function () {
      el.classList.add('is-open');
      var x = el.querySelector('.sp-x');
      if (x) x.focus();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ov) closeSheet();
  });

  function lockUI(on) {
    state.busy = on;
    Array.prototype.forEach.call(root.querySelectorAll('button'), function (b) { b.disabled = on; });
  }

  function refresh(msg) {
    return fetchList().then(function (list) {
      render(list);
      if (msg) toast(msg);
    });
  }

  function doSkip(id) {
    if (!WRITE_ENABLED) { toast('\u3053\u306e\u64cd\u4f5c\u306f\u73fe\u5728\u6e96\u5099\u4e2d\u3067\u3059'); return; }
    if (state.busy) return;
    lockUI(true);
    call('POST', '/api/v1/skip', { contractId: gidOf(id) })
      .then(function () { lockUI(false); return refresh('\u6b21\u56de\u306e\u304a\u5c4a\u3051\u3092\u30b9\u30ad\u30c3\u30d7\u3057\u307e\u3057\u305f'); })
      .catch(function (e) {
        console.error('[sp] skip', e); lockUI(false);
        toast('\u51e6\u7406\u3067\u304d\u307e\u305b\u3093\u3067\u3057\u305f\u3002\u518d\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002', true);
      });
  }

  function doResume(id) {
    if (!WRITE_ENABLED) { toast('\u3053\u306e\u64cd\u4f5c\u306f\u73fe\u5728\u6e96\u5099\u4e2d\u3067\u3059'); return; }
    if (state.busy) return;
    lockUI(true);
    call('POST', '/api/v1/resume', { contractId: gidOf(id) })
      .then(function () { lockUI(false); return refresh('\u5b9a\u671f\u4fbf\u3092\u518d\u958b\u3057\u307e\u3057\u305f'); })
      .catch(function (e) {
        console.error('[sp] resume', e); lockUI(false);
        toast('\u51e6\u7406\u3067\u304d\u307e\u305b\u3093\u3067\u3057\u305f\u3002\u518d\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002', true);
      });
  }

  function sortByDate(a, b) {
    var x = parseDate(a.nextBillingDate), y = parseDate(b.nextBillingDate);
    if (!x) return 1;
    if (!y) return -1;
    return x - y;
  }
  function groupHead(title, count, icon) {
    return '<div class="sp-group-head">' + (icon || '') + '<h2>' + esc(title) + '</h2>' +
      (count ? '<span class="sp-count">' + count + '\u4ef6</span>' : '') + '</div>';
  }

  function render(list) {
    store = {};
    list.forEach(function (c) { if (c.contractId) store[c.contractId] = c; });

    var active = [], paused = [], ended = [];
    list.forEach(function (c) {
      if (c.status === 'PAUSED') paused.push(c);
      else if (c.status === 'CANCELLED' || c.status === 'EXPIRED') ended.push(c);
      else active.push(c);
    });
    active.sort(sortByDate);
    paused.sort(sortByDate);
    ended.sort(sortByDate).reverse();

    if (!active.length && !paused.length && !ended.length) {
      root.innerHTML = '<div class="sp-empty">\u5b9a\u671f\u4fbf\u306e\u3054\u5951\u7d04\u306f\u3042\u308a\u307e\u305b\u3093\u3002<br>' +
        '<a href="' + esc(SHOP_URL) + '">\u5b9a\u671f\u4fbf\u306e\u5546\u54c1\u3092\u898b\u308b</a></div>';
      return;
    }

    var h = '<div class="sp-group">' + groupHead('\u304a\u5c4a\u3051\u4e2d', active.length, ICON.truck);
    if (active.length) {
      h += heroHTML(active[0]);
      for (var i = 1; i < active.length; i++) {
        h += cardHTML(active[i], [fmtDate(parseDate(active[i].nextBillingDate)), intervalLabel(active[i])].filter(Boolean).join(' \uff0f '));
      }
    } else {
      h += '<div class="sp-empty-sm">\u73fe\u5728\u304a\u5c4a\u3051\u4e2d\u306e\u5b9a\u671f\u4fbf\u306f\u3042\u308a\u307e\u305b\u3093\u3002</div>';
    }
    h += '</div>';

    if (paused.length) {
      h += '<div class="sp-group">' + groupHead('\u304a\u4f11\u307f\u4e2d', paused.length, ICON.pause) +
        '<p class="sp-group-note">\u518d\u958b\u3059\u308b\u3068\u3001\u6b21\u56de\u306e\u304a\u5c4a\u3051\u304b\u3089\u518d\u3073\u3054\u5229\u7528\u3044\u305f\u3060\u3051\u307e\u3059\u3002</p>';
      paused.forEach(function (c, i) {
        h += i < PAUSED_VISIBLE ? pausedHTML(c)
          : '<div class="sp-paused-extra sp-hidden">' + pausedHTML(c) + '</div>';
      });
      if (paused.length > PAUSED_VISIBLE) {
        h += '<button type="button" class="sp-more" data-act="more-paused">\u6b8b\u308a' +
          (paused.length - PAUSED_VISIBLE) + '\u4ef6\u3092\u8868\u793a</button>';
      }
      h += '</div>';
    }

    if (ended.length) {
      h += '<details class="sp-fold sp-ended"><summary><div class="sp-fold-btn">' +
        '<span>\u89e3\u7d04\u6e08\u307f\u306e\u5b9a\u671f\u4fbf\uff08' + ended.length + '\u4ef6\uff09</span>' +
        ICON.down + '</div></summary><div class="sp-fold-body">';
      ended.forEach(function (c) { h += cardHTML(c, STATUS_JA[c.status] || '\u7d42\u4e86'); });
      h += '</div></details>';
    }

    h += addNewHTML();
    root.innerHTML = h;
  }

  function getToken() {
    return fetch(API_BASE, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').getElementById('customerIdHash');
        if (!el) throw new Error('token not found');
        return el.textContent.trim();
      });
  }

  function fetchList() {
    return fetch(API_BASE + '/api/v2/subscriptions' + qs(), {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ lineCount: 5, first: 20, last: null, after: null, before: null })
    }).then(function (r) {
      if (!r.ok) throw new Error('list failed ' + r.status);
      return r.json();
    }).then(function (d) { return (d && d.subscriptionContracts) || []; });
  }

  root.addEventListener('click', function (e) {
    var more = e.target.closest('[data-act="more-paused"]');
    if (more) {
      e.preventDefault();
      Array.prototype.forEach.call(root.querySelectorAll('.sp-paused-extra'), function (n) {
        n.classList.remove('sp-hidden');
      });
      more.remove();
      return;
    }
    var d = e.target.closest('[data-act="detail"]');
    if (d) {
      e.preventDefault();
      var c = store[d.dataset.id];
      if (c) openSheet(c);
      return;
    }
    var sk = e.target.closest('[data-act="skip"]');
    if (sk) { e.preventDefault(); doSkip(sk.dataset.id); return; }
    var rs = e.target.closest('[data-act="resume"]');
    if (rs) { e.preventDefault(); doResume(rs.dataset.id); }
  });

  function boot() {
    state.cid = window.__st && window.__st.cid;
    if (!state.cid) {
      root.innerHTML = '<div class="sp-empty">\u30ed\u30b0\u30a4\u30f3\u3057\u3066\u304f\u3060\u3055\u3044\u3002<br>' +
        '<a href="/account/login">\u30ed\u30b0\u30a4\u30f3\u3078</a></div>';
      return;
    }
    getToken()
      .then(function (t) { state.token = t; return fetchList(); })
      .then(function (list) { render(list); })
      .catch(function (err) {
        console.error('[sp]', err);
        root.innerHTML = '<div class="sp-error">\u5b9a\u671f\u4fbf\u60c5\u5831\u3092\u8aad\u307f\u8fbc\u3081\u307e\u305b\u3093\u3067\u3057\u305f\u3002' +
          '<br>\u304a\u624b\u6570\u3067\u3059\u304c\u3001\u6642\u9593\u3092\u304a\u3044\u3066\u518d\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002' +
          '<br><a href="tel:0345000424">\u304a\u96fb\u8a71\u3067\u306e\u304a\u554f\u5408\u305b 03-4500-0424</a></div>';
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
